// extracted by mini-css-extract-plugin
export default {"table":"uAOjvYXFZa","group-heading":"_1aig1fwIfv","groupHeading":"_1aig1fwIfv","sub":"_3yoSZevCLP","not-available":"_1jp13sO-f_","notAvailable":"_1jp13sO-f_"};
    if(module.hot) {
      // 1625219462613
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  